import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { MatchSummaryPlannerFragmentDoc, MatchSummaryMatchStatusFragmentDoc } from './MatchSummary/MatchSummary.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type MembersReportPagePlannerFragment = { __typename?: 'Planner', name: string, id: string };

export type MembersReportPageMatcuStatusFragment = { __typename?: 'MatchStatus', plannerId: string, inflowSource: string, numberOfMessages: number, createdAt: TimeString, hasTalked: boolean };

export type MembersReportPageForCorporationQueryVariables = Types.Exact<{
  since: Types.Scalars['Date']['input'];
  until: Types.Scalars['Date']['input'];
}>;


export type MembersReportPageForCorporationQuery = { __typename?: 'Query', plannersInSameCorporation: Array<{ __typename?: 'Planner', name: string, id: string }>, matchStatusesInSameCorporation: { __typename: 'MatchStatusesInSameCorporationErrorNotAuthorityPayload' } | { __typename: 'MatchStatusesInSameCorporationSuccessPayload', matchStatuses: Array<{ __typename?: 'MatchStatus', plannerId: string, inflowSource: string, numberOfMessages: number, createdAt: TimeString, hasTalked: boolean }> } };

export type MembersReportPageForBranchQueryVariables = Types.Exact<{
  since: Types.Scalars['Date']['input'];
  until: Types.Scalars['Date']['input'];
}>;


export type MembersReportPageForBranchQuery = { __typename?: 'Query', plannersInSameBranch: Array<{ __typename?: 'Planner', name: string, id: string }>, matchStatusesInSameBranch: { __typename: 'MatchStatusesInSameBranchErrorNotAuthorityPayload' } | { __typename: 'MatchStatusesInSameBranchSuccessPayload', matchStatuses: Array<{ __typename?: 'MatchStatus', plannerId: string, inflowSource: string, numberOfMessages: number, createdAt: TimeString, hasTalked: boolean }> } };

export type MembersReportPageQueryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MembersReportPageQueryQuery = { __typename?: 'Query', uiControl: { __typename?: 'UIControl', viewBranchReport: boolean, viewCorporationReport: boolean } };

export const MembersReportPagePlannerFragmentDoc = gql`
    fragment MembersReportPagePlanner on Planner {
  ...MatchSummaryPlanner
}
    ${MatchSummaryPlannerFragmentDoc}`;
export const MembersReportPageMatcuStatusFragmentDoc = gql`
    fragment MembersReportPageMatcuStatus on MatchStatus {
  ...MatchSummaryMatchStatus
}
    ${MatchSummaryMatchStatusFragmentDoc}`;
export const MembersReportPageForCorporationDocument = gql`
    query MembersReportPageForCorporation($since: Date!, $until: Date!) {
  plannersInSameCorporation {
    ...MembersReportPagePlanner
  }
  matchStatusesInSameCorporation(since: $since, until: $until) {
    __typename
    ... on MatchStatusesInSameCorporationSuccessPayload {
      matchStatuses {
        ...MembersReportPageMatcuStatus
      }
    }
  }
}
    ${MembersReportPagePlannerFragmentDoc}
${MembersReportPageMatcuStatusFragmentDoc}`;

/**
 * __useMembersReportPageForCorporationQuery__
 *
 * To run a query within a Vue component, call `useMembersReportPageForCorporationQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersReportPageForCorporationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMembersReportPageForCorporationQuery({
 *   since: // value for 'since'
 *   until: // value for 'until'
 * });
 */
export function useMembersReportPageForCorporationQuery(variables: MembersReportPageForCorporationQueryVariables | VueCompositionApi.Ref<MembersReportPageForCorporationQueryVariables> | ReactiveFunction<MembersReportPageForCorporationQueryVariables>, options: VueApolloComposable.UseQueryOptions<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables>(MembersReportPageForCorporationDocument, variables, options);
}
export function useMembersReportPageForCorporationLazyQuery(variables?: MembersReportPageForCorporationQueryVariables | VueCompositionApi.Ref<MembersReportPageForCorporationQueryVariables> | ReactiveFunction<MembersReportPageForCorporationQueryVariables>, options: VueApolloComposable.UseQueryOptions<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables>(MembersReportPageForCorporationDocument, variables, options);
}
export type MembersReportPageForCorporationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MembersReportPageForCorporationQuery, MembersReportPageForCorporationQueryVariables>;
export const MembersReportPageForBranchDocument = gql`
    query MembersReportPageForBranch($since: Date!, $until: Date!) {
  plannersInSameBranch {
    ...MembersReportPagePlanner
  }
  matchStatusesInSameBranch(since: $since, until: $until) {
    __typename
    ... on MatchStatusesInSameBranchSuccessPayload {
      matchStatuses {
        ...MembersReportPageMatcuStatus
      }
    }
  }
}
    ${MembersReportPagePlannerFragmentDoc}
${MembersReportPageMatcuStatusFragmentDoc}`;

/**
 * __useMembersReportPageForBranchQuery__
 *
 * To run a query within a Vue component, call `useMembersReportPageForBranchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersReportPageForBranchQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMembersReportPageForBranchQuery({
 *   since: // value for 'since'
 *   until: // value for 'until'
 * });
 */
export function useMembersReportPageForBranchQuery(variables: MembersReportPageForBranchQueryVariables | VueCompositionApi.Ref<MembersReportPageForBranchQueryVariables> | ReactiveFunction<MembersReportPageForBranchQueryVariables>, options: VueApolloComposable.UseQueryOptions<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables>(MembersReportPageForBranchDocument, variables, options);
}
export function useMembersReportPageForBranchLazyQuery(variables?: MembersReportPageForBranchQueryVariables | VueCompositionApi.Ref<MembersReportPageForBranchQueryVariables> | ReactiveFunction<MembersReportPageForBranchQueryVariables>, options: VueApolloComposable.UseQueryOptions<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables>(MembersReportPageForBranchDocument, variables, options);
}
export type MembersReportPageForBranchQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MembersReportPageForBranchQuery, MembersReportPageForBranchQueryVariables>;
export const MembersReportPageQueryDocument = gql`
    query MembersReportPageQuery {
  uiControl {
    viewBranchReport
    viewCorporationReport
  }
}
    `;

/**
 * __useMembersReportPageQueryQuery__
 *
 * To run a query within a Vue component, call `useMembersReportPageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMembersReportPageQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMembersReportPageQueryQuery();
 */
export function useMembersReportPageQueryQuery(options: VueApolloComposable.UseQueryOptions<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables>(MembersReportPageQueryDocument, {}, options);
}
export function useMembersReportPageQueryLazyQuery(options: VueApolloComposable.UseQueryOptions<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables>(MembersReportPageQueryDocument, {}, options);
}
export type MembersReportPageQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MembersReportPageQueryQuery, MembersReportPageQueryQueryVariables>;